import store from '@/store/index.js'; // 引入vuex
let debounceTimer = null;

/**
 * 整数转26字母数字
 * @param {number} num
 * @return {string}
 */
const convertFn = num => {
    if (num <= 26) {
        return String.fromCharCode(num + 64);
    } else {
        let str = convertFn(~~((num - 1) / 26)) + '_' + convertFn(num % 26 || 26);

        return str;
    }
};

export default {
    /* 对象转url */
    parseParam(param) {
        return Object.keys(param).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(param[key]).join('&'));
    },

    // 实现获取当前时间年的第几周的方法
    getMonthWeek(date) {
        var today = date || new Date();
        var firstDay = new Date(today.getFullYear(), 0, 1);
        var dayOfWeek = firstDay.getDay();
        var spendDay = 1;
        if (dayOfWeek != 0) {
            spendDay = 7 - dayOfWeek + 1;
        }
        firstDay = new Date(today.getFullYear(), 0, 1 + spendDay);
        var d = Math.ceil((today.valueOf() - firstDay.valueOf()) / 86400000);
        var result = Math.ceil(d / 7);
        return result;
    },

    /**
     * @description 以空格分开的字符串，处理成空格处首字母大写
     * @param {string} str abc def
     * @returns {string} str Abc Def
     */
    titleCase(str) {
        var arr = str.toLowerCase().split(' '); //字符串以空格为界限转换为数组
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1); //charAt()方法得到第一个字母，slice()得到第二个字母以后的字符串
        }
        str = arr.join(' '); //合并数组为字符串
        return str;
    },

    /* 深拷贝-拷贝函数 */
    deepCopy(obj) {
        var result = Array.isArray(obj) ? [] : {};
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    result[key] = this.deepCopy(obj[key]); // 递归复制
                } else {
                    result[key] = obj[key];
                }
            }
        }
        return result;
    },

    /* 浅拷贝-拷贝函数 */
    copy(obj) {
        if (typeof obj !== 'object') {
            throw '请传入对象';
        }
        return JSON.parse(JSON.stringify(obj));
    },

    checkSuffix(fileName) {
        /**
         * 检查是不是图片
         * @param fileName
         * @returns {boolean}
         */
        const imgSuffixs = ['bmp', 'jpg', 'jpeg', 'png', 'gif'];
        const index = fileName.lastIndexOf('.');
        const suffix = fileName.substr(index + 1).toLowerCase();

        if (!suffix) {
            return false;
        }
        return imgSuffixs.includes(suffix);
    },

    /*
     检测文件返回的格式
    */
    formatSuffix(name) {
        let arr = name.split('.');
        let ext = arr[arr.length - 1].toLowerCase();
        let fileTypeArr = ['mp4', 'ppt', 'xls', 'xlsx', 'doc', 'pdf', 'jpg', 'png', 'jpeg', 'mov'];
        if (fileTypeArr.includes(ext)) return ext;
        return 'other';
    },

    // 根据文件类型显示对应的图片icon
    formatSuffixIcon(fileName) {
        let suffix = this.formatSuffix(fileName);
        return require('@i/document/' + suffix + '.svg');
    },

    /**
     * @author zhangjun
     * @description  时间转换，传入指定时间格式和一个任何可以被new Date(date)解析的字面量
     * @param {string} fmt 时间格式 如 'YYYY-MM-DD HH:mm:ss' 'mm/ss'
     * @param {any} 时间戳 日期字符串 或者一个Date对象
     * @return {fmt} 转换的时间字符串
     */
    formatTime(fmt, date) {
        let ret;
        date = new Date(date ? date : new Date());
        const opt = {
            'Y+': date.getFullYear().toString(), // 年
            'M+': (date.getMonth() + 1).toString(), // 月
            'D+': date.getDate().toString(), // 日
            'H+': date.getHours().toString(), // 时
            'm+': date.getMinutes().toString(), // 分
            's+': date.getSeconds().toString(), // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp('(' + k + ')').exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
            }
        }
        return fmt;
    },
    // 时间转化成时分秒
    formatTime1(result) {
        let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
        let m = Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
        let s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
        return Math.floor(result / 3600) == 0 ? m + ':' + s : h + ':' + m + ':' + s;
    },
    // 校验微信号
    chkIt(str) {
        let weixin = /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/;
        if (weixin.test(str)) {
            return true;
        } else {
            return false;
        }
    },

    // 校验手机号
    validTel(tel) {
        const reg = /^1[3456789][0-9]{9}$/;
        return reg.test(tel);
    },

    // 校验邮箱
    validEmail(email) {
        const reg = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return reg.test(email);
    },

    // 校验护照
    checkPassport(code) {
        let Passport = /^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/;
        if (Passport.test(code)) {
            return true;
        } else {
            return false;
        }
    },

    // 检查字符串是否是中文名，要求 汉字个数>=2 <=20
    checkName(code) {
        let name = /^[\u4E00-\u9FA5]{2,20}$/;
        if (name.test(code)) {
            return true;
        } else {
            return false;
        }
    },

    // 检查字符串是否是英文名，要求纯英文
    checkNameEn(code) {
        let nameEn = /[a-zA-Z]+\/[a-zA-Z]+/;
        if (nameEn.test(code)) {
            return true;
        } else {
            return false;
        }
    },

    // 检查字符串是否含有中文
    check(str) {
        if (escape(str).indexOf('%u') != -1) {
            return true;
        } else {
            return false;
        }
    },

    // 校验身份证号
    checkIdCard(id) {
        // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
        var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
        //号码规则校验
        if (!format.test(id)) {
            return true;
        }
        //区位码校验
        //出生年月日校验  前正则限制起始年份为1900;
        var year = id.substr(6, 4), //身份证年
            month = id.substr(10, 2), //身份证月
            date = id.substr(12, 2), //身份证日
            time = Date.parse(month + '-' + date + '-' + year), //身份证日期时间戳date
            now_time = Date.parse(new Date()), //当前时间戳
            dates = new Date(year, month, 0).getDate(); //身份证当月天数
        if (time > now_time || date > dates) {
            return true;
        }
        //校验码判断
        var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
        var b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'); //校验码对照表
        var id_array = id.split('');
        var sum = 0;
        for (var k = 0; k < 17; k++) {
            sum += parseInt(id_array[k]) * parseInt(c[k]);
        }
        if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
            return true;
        }
        return false;
    },

    /* windows || mac */
    winOrMac() {
        var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
        return isMac ? 'mac' : 'win';
    },

    /* dom转string，去掉image的href=base64 */
    handleHTML(item) {
        if (item.type === 'image') {
            // 如果是图片，去掉base64
            const clone = item.node.cloneNode(true);
            clone.setAttribute('href', '');
            return clone.outerHTML;
        } else {
            return item.node.outerHTML;
        }
    },

    /**
     * @author zhudying
     * @description  文件流下载pdf
     * @function exportPdf    pdf下载函数
     * @param  data  文件流数据，后端请求返回
     * @param {string}  fileName  文件名（xx.pdf）
     *
     */
    exportPng(data, filename) {
        let blob = new Blob([data], {
            //type类型后端返回来的数据中会有，根据自己实际进行修改
            // 表格下载为 application/xlsx，压缩包为 application/zip等，
            type: 'application/png',
        });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(blob, filename);
        } else {
            var blobURL = window.URL.createObjectURL(blob);
            // 创建隐藏<a>标签进行下载
            var tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = blobURL;
            tempLink.setAttribute('download', filename);
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }
    },
    /**
     * @author zhudying
     * @description  国籍转换中英文
     * @param {string} country  当前国籍别称 alpha2
     * @param {Array}  countryList  所有国籍list
     * @return {string} name  国籍名称
     */
    changeCountry(country, countryList) {
        let name = '';
        countryList.map(map => {
            if (country == map.alpha2) {
                name = map.name;
            }
        });
        return name;
    },

    /**
     * @author zhangchao
     * @description  获取默认随机头像
     * @param {array} data  头像数据
     * @param {string} type  men/women/boy/girl
     * @return {string} url  头像url
     */
    getDefaultAvatar(data, type) {
        let randomNum = Math.floor(Math.random() * 4.5); //0~4的随机数
        let url = data[type][randomNum];

        return url;
    },

    /**
     * @description 处理await错误信息，不用try catch来捕获 const res = await this.$utils.awaitErr(this.$server.getList())
     * @param {promise} promise 传入一个axios请求
     * @returns {array} [err, res]
     */
    awaitErr(promise) {
        return promise.then(data => [null, data]).catch(err => [err, null]);
    },

    // 判断数组返回翻译 list 数组 key后台数据 label需要值字段 value对比字段
    // 例：list = [{name: '中文', nameEn: 'English', key: 'key1'}], 取'key1'的中英文
    //    $utils.getValueByKey(list, 'key1', 'name', 'key');
    getValueByKey(list, key, label, value) {
        for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (item[value] == key) {
                let language = store.state.language.charAt(0).toUpperCase() + store.state.language.substring(1);
                if (item[label + language]) {
                    return item[label + language];
                } else {
                    return item[label];
                }
            }
        }
    },

    /**
     * 返回上一页
     */
    goBack(that) {
        // that.$route.meta.keepAlive = true; // 用于上一页缓存
        that.$router.isBack = true;
        that.$router.go(-1);
    },

    /**
     * @author zhangchao
     * @description  性别
     * @param {number} sex  当前性别
     * @return {string} 男女
     */
    getSex(sex) {
        switch (sex) {
            case 1:
                return '男';
            case 2:
                return '女';
        }
    },

    /**
     * @author zhangchao
     * @description  性别icon
     * @param {number} gender  当前性别
     * @return {string} icon
     */
    sexIcon(gender) {
        let man = require('@i/common/sex-man.svg');
        let woman = require('@i/common/sex-woman.svg');
        let icon = gender == 1 ? man : gender == 2 ? woman : '';
        return icon;
    },

    /**
     *  转换文件件 limit 为 Byte
     * @param { Number } 文件大小
     */
    unitTran(limit) {
        if (limit == 0) return '0B';
        if (!limit) return '-';
        limit = Number(limit);
        // size 是 Byte
        let size = '';
        if (limit < 0.1 * 1024) {
            //如果小于0.1KB转化成B
            size = limit.toFixed(2) + 'B';
        } else if (limit < 0.1 * 1024 * 1024) {
            //如果小于0.1MB转化成KB
            size = (limit / 1024).toFixed(2) + 'KB';
        } else if (limit < 0.1 * 1024 * 1024 * 1024) {
            //如果小于0.1GB转化成MB
            size = (limit / (1024 * 1024)).toFixed(2) + 'MB';
        } else {
            //其他转化成GB
            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB';
        }
        let result = size + '';

        // //当小数点后为00时 去掉小数部分
        // var len = sizestr.indexOf('.');
        // var dec = sizestr.substr(len + 1, 2);
        // if (dec == '00') {
        //     return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
        // }
        return result;
    },
    /**
     *  转换文件件 limit 为 Byte
     * @param { Number } 文件大小
     */
    reverseUnitTran(limit) {
        if (limit.indexOf('KB') > -1) {
            let i = limit.indexOf('KB');
            let res = limit.substr(0, i);
            res = res - 0;
            return res * 1024;
        }
        if (limit.indexOf('MB') > -1) {
            let i = limit.indexOf('MB');
            let res = limit.substr(0, i);
            res = res - 0;
            // console.log(res, 'res-1');

            return res * 1024 * 1024;
        }
        if (limit.indexOf('G') > -1) {
            let i = limit.indexOf('GB');
            let res = limit.substr(0, i);
            res = res - 0;
            return res * 1024 * 1024 * 1024;
        }
        return limit;
    },
    /**
     *  arrayBuffer 转 base64
     * @param { buffer } 文件流
     */
    arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        for (var len = bytes.byteLength, i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    },
    /**
     * @dec   base64 加密方式
     */
    encryption(data) {
        return window.btoa(encodeURIComponent(JSON.stringify(data)));
    },
    /**
     * @dec   base64 解密方式
     */
    decrypt(data) {
        return JSON.parse(decodeURIComponent(window.atob(data)));
    },
    // 生成uuid方法
    uuid() {
        let s = [];
        let hexDigits = '0123456789abcdef';
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';

        let uuid = s.join('');
        return uuid;
    },

    getOneMonthDays(time) {
        // 获取当前月的开始和结束
        // 传入当前的年份和月份 格式为YYYY/MM
        let timeYear = time.substr(0, 4);
        let timeMonth = time.substr(5);
        let month = Number(timeMonth) - 1;
        let baseMonthsDays = [];
        let date = new Date(timeYear.toString() ? timeYear + '' : new Date());
        let year = date.getFullYear();
        for (let i = 0; i < 12; i++) {
            let monthData = new Date(year, i + 1, 0); // 获取一个月最后一天的日期
            let monthDataLength = monthData.getDate();
            baseMonthsDays.push(monthDataLength);
        }
        if (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0)) {
            if (month === 2) {
                baseMonthsDays[month] = 29;
            }
        }
        return baseMonthsDays[month];
    },
    //HEX十六进制颜色值转换为RGB(A)颜色值
    hexToRgb(hex, opc) {
        let rgbaArry = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt('0x' + hex.slice(3, 5))},${parseInt('0x' + hex.slice(5, 7))},${opc})`;
        return rgbaArry;
    },
    /**
     * 格式化日期
     * @param date new Date(xx) 格式
     * @param fmt 转换格式，默认xx/xx/xx
     * @returns {string}
     */
    dateFormat(date, fmt = 'yyyy/MM/dd') {
        if (date == 'Invalid Date' || !date) return '';
        // Invalid Date
        // 格式化时间-- 使用 dateFormat(new Date(), 'yyyy/MM/dd hh:mm:ss')
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        let o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds(),
        };
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + '';
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
            }
        }
        return fmt;
    },

    /**
     * @desc 秒数转换时分秒 180秒 => 00:03:00
     * @param {Number} value
     * @param {string} flag full|computed full时分秒 00:00:00， computed计算后超过1小时是00:00:00，没超过是00:00
     * @returns 00:03:00格式的时间
     */
    timeFormat(value, flag = 'full') {
        var theTime = parseInt(value); // 秒
        var minute = 0; // 分
        var hour = 0; // 小时
        let addZero = num => {
            if (!num) return '00';
            return parseInt(num) < 10 ? '0' + num : num;
        };

        if (theTime > 60) {
            minute = parseInt(theTime / 60);
            theTime = parseInt(theTime % 60);
            if (minute > 60) {
                hour = parseInt(minute / 60);
                minute = parseInt(minute % 60);
            }
        }
        if (flag === 'full') {
            return addZero(hour) + ':' + addZero(minute) + ':' + addZero(theTime);
        } else {
            return Math.floor(value / 3600) == 0 ? addZero(minute) + ':' + addZero(theTime) : addZero(hour) + ':' + addZero(minute) + ':' + addZero(theTime);
        }
    },
    /**
     * @desc 节流
     * @param func 函数
     * @param wait 延迟执行毫秒数
     */
    throttle(fn, wait = 100) {
        let inThrottle, lastFn, lastTime;
        return function() {
            const context = this;
            const args = arguments;
            if (!inThrottle) {
                fn.apply(context, args);
                lastTime = Date.now();
                inThrottle = true;
            } else {
                clearTimeout(lastFn);
                lastFn = setTimeout(function() {
                    if (Date.now() - lastTime >= wait) {
                        fn.apply(context, args);
                        lastTime = Date.now();
                    }
                }, Math.max(wait - (Date.now() - lastTime), 0));
            }
        };
    },

    /**
     * @desc 修改表格背景
     * @param event 当前点击节点
     * @param flag 清除掉背景 需传入 ----  empty
     * 例：
     *         @click="***($event, row)"
     * 1.设置：this.$utils.rowFn(event);
     * 2.清除：this.$utils.rowFn(event, 'empty');
     */
    rowFn(event, flag = '') {
        // 查找当前点击的父级元素
        if (!event) {
            return;
        }
        let path = event.path;
        let tableEl = path.find(node => node.nodeName === 'TABLE');
        let current = tableEl.querySelector('.current-row');
        if (current) current.classList.remove('current-row');

        let rowEl = path.find(node => node.nodeName === 'TR');
        if (flag === 'empty') {
            rowEl.classList.remove('current-row');
        } else {
            rowEl.classList.add('current-row');
        }
    },
    /**
     * @desc 时分秒转成成秒
     * @param func 函数
     * @param e 10:10:10 格式的时间
     */
    changeTimeByH(e) {
        var time = e;
        var len = time.split(':');
        if (len.length == 3) {
            let hour = time.split(':')[0];
            let min = time.split(':')[1];
            let sec = time.split(':')[2];
            return Number(hour * 3600) + Number(min * 60) + Number(sec);
        }
        if (len.length == 2) {
            let min = time.split(':')[0];
            let sec = time.split(':')[1];
            return Number(min * 60) + Number(sec);
        }
        if (len.length == 1) {
            let sec = time.split(':')[0];
            return Number(sec);
        }
        return 0;
    },
    // 周换算
    weekFn(e, type) {
        switch (e) {
            case 1:
                return type == 'en' ? 'Mon' : '周一';
            case 2:
                return type == 'en' ? 'Tue' : '周二';
            case 3:
                return type == 'en' ? 'Wed' : '周三';
            case 4:
                return type == 'en' ? 'Thu' : '周四';
            case 5:
                return type == 'en' ? 'Fri' : '周五';
            case 6:
                return type == 'en' ? 'Sat' : '周六';
            case 7:
                return type == 'en' ? 'Sun' : '周日';
        }
    },

    /* 防抖 */
    debounce(fn, time = 300) {
        debounceTimer && clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => fn(), time);
    },

    /**
     * @desc 删除弹框模板
     * @param Func h函数
     * @param obj  对象
     * obj.msg：描述
     * obj.name：人名
     *
     */
    hFunc(Func, obj) {
        return Func('p', null, [Func('span', {}, `${obj.msg}`), Func('span', { style: 'color:#3663E1;word-break:break-all;' }, `“${obj.name}”`), obj.label ? Func('span', {}, `${obj.label}`) : '', Func('span', {}, `？`)]);
    },
    getArrMax(arr) {
        let newArr = this.deepCopy(arr);
        return newArr.sort((a, b) => {
            return b - a;
        })[0];
    },
    /**
     * @author sxx
     * @description 将图片转成base64，防止截图时，无法找到图片
     * @param {url} url - 图片引入路径名称
     * @returns 无
     */
    getBase64Image(url) {
        var img = new Image();
        img.src = url;
        return new Promise((resolve, reject) => {
            img.onload = () => {
                var canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, img.width, img.height);
                var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
                var dataURL = canvas.toDataURL('image/' + ext);
                resolve(dataURL);
            };
            img.onerror = () => {
                console.log('error');
            };
        });
    },

    /**
     * 整数转罗马数字
     * @param {number} num
     * @return {string}
     */
    intToRoman(num) {
        let M = ['', 'M', 'MM', 'MMM'];
        let C = ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM'];
        let X = ['', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'];
        let I = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
        return M[parseInt(String(num / 1000))] + C[parseInt(String((num % 1000) / 100))] + X[parseInt(String((num % 100) / 10))] + I[num % 10];
    },

    /**
     * 整数转26字母数字
     * @param {number} num
     * @return {string}
     */
    convertFn,

    /**
     * @desc Iframe参数及路径拼接
     * @params 除公共参数外的额外参数
     * @url 第三方路径
     * @return 处理后的路径
     */
    getIframeParams(params, url, tokenStr) {
        const { token, language, tenantId, groupId } = store.state;
        const iframeParams = {
            xTenantId: tenantId || groupId,
            token,
            language,
            ...params,
        };

        // tokenStr 标记是否需要token，传notToken表示不需要，不传则默认需要token
        tokenStr === 'notToken' && delete iframeParams.token;

        console.log('iframeParams', iframeParams);
        return `${url}?${new URLSearchParams(iframeParams).toString()}`;
    },
     /**
     * @desc 获取动态字段场景值
     * @sceneKey 除公共参数外的额外参数
     */
    getFieldsScene(sceneKey) {
        const sceneObj = {
            player: {
                name: '球员信息表头',
                nameEn: 'player info header',
                type: 'player',
                key: 'player_info_header'
            },
            staff: {
                name: '职员信息表头',
                nameEn: 'staff info header',
                type: 'staff',
                key: 'staff_info_header'
            },
            playerRoster: {
                name: '球员训练营花名册',
                nameEn: 'player roster camp',
                type: 'player',
                key: 'player_camp_roster'
            },
            staffRoster: {
                name: '教练员训练营花名册',
                nameEn: 'staff roster camp',
                type: 'staff',
                key: 'staff_camp_roster'
            },
            playerScoutList: {
                type: 'player',
                key: 'player_scout_list'
            },
            scoutAllPlayerHeader: {
                type: 'player',
                key: 'scout_all_player_header'
            }
        };
        // console.log('sceneObj[sceneKey]', sceneObj[sceneKey]);
        return sceneObj[sceneKey];
    },
    /**
     * @desc 对象设置新的属性
     * @params targetObj - 目标对象
     * @params mapObj - 映射对象
     * @params valueKey - 新增加的属性key名
     */
    objectSetValue(targetObj, mapObj, valueKey) {
        Object.keys(targetObj).forEach(key => {
            targetObj[key].forEach(item => {
                item[valueKey] = mapObj[item.id];
            });
        });
    },
};
